module.exports = __webpack_public_path__ + "img/comentario.3ba85947.svg";